import { render, staticRenderFns } from "./ProjectPublishButton.vue?vue&type=template&id=1dff62c7&scoped=true&"
import script from "./ProjectPublishButton.vue?vue&type=script&lang=ts&"
export * from "./ProjectPublishButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dff62c7",
  null
  
)

export default component.exports